import NumberPagination from './NumberPagination';
export default NumberPagination;
